module.exports = __webpack_public_path__ + "img/inventory_button.02056594.png";